<template>
  <section class="subscribe-page">
    <SubscribeForm/>
  </section>
</template>

<script>

import SubscribeForm from '@/components/SubscribeForm.vue'

export default {
  name: 'Subscribe',
  components: {
    SubscribeForm
  },
  props: {}
}
</script>

<style scoped lang="scss">


</style>
